import type { AgoraParticipantLike } from '../../types';
import useParticipants from '../../hooks/useParticipants/useParticipants';
import useTracks from '../../hooks/useTracks/useTracks';
import AudioTrack from '../AudioTrack/AudioTrack';

function Participant({ participant }: { participant: AgoraParticipantLike }) {
  const tracks = useTracks(participant);
  const audioTrack = tracks.find((t: any) => t?.trackMediaType === 'audio' || t?.kind === 'audio');

  if (audioTrack) return <AudioTrack track={audioTrack} />;
  return null;
}

export function ParticipantAudioTracks() {
  const participants = useParticipants();

  return (
    <>
      {participants.map(participant => (
        <Participant key={String(participant.uid)} participant={participant} />
      ))}
    </>
  );
}
